import {Box, Button, Menu, MenuItem, Tooltip} from '@mui/material'
import {FolderKey, UserKey} from 'lucide-react'
import {useState} from 'react'
import {useAuth} from 'src/contexts/AuthContext'
import Delete from 'src/images/deleteIconBlack.svg'
import createStyleSheet from 'src/utilities/createStyleSheet'
import actionsObject from '../../../images/actionsObject.svg'
import IconEditUser from '../../../images/iconEditUser.svg'
import IconEmail from '../../../images/iconEmail.svg'
import PermissionUser from '../../../images/userPermission.svg'
import {UserRow} from './UserGridTable'

type LprTooltipEvent = 'set-permissions' | 'edit-user' | 'delete' | 'send-email' | 'create-api-key' | 'manage-api-key'

type LprInfos = {
  params: UserRow
  onClick?: (event: LprTooltipEvent) => void
  hasDeletePermission: boolean
  hasCreateApiKeyPermission: boolean
  hasManageApiKeyPermission: boolean
  disabledRoles: string[]
  isRoleAdmin?: boolean
}

const UserMenuOptions = ({params, onClick, hasDeletePermission, disabledRoles, hasCreateApiKeyPermission, hasManageApiKeyPermission}: LprInfos) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isRoleAdmin = params.role === 'admin'
  const open = !isRoleAdmin && Boolean(anchorEl)
  const {user} = useAuth()

  return (
    <>
      <Tooltip title='Opções' placement='top'>
        <Button
          sx={{height: '26px', minWidth: '5px'}}
          onClick={(event) => {
            event.stopPropagation()
            setAnchorEl(event.currentTarget)
          }}>
          <img src={actionsObject} alt='Menu logo' style={{width: 20, height: 20}} />
        </Button>
      </Tooltip>
      <Menu
        id='fade-menu'
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          setAnchorEl(null)
        }}>
        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('edit-user')
          }}>
          <img src={IconEditUser} alt='Menu logo' style={{width: 15, height: 15}} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Editar Usuário</Box>
        </MenuItem>
        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('create-api-key')
          }}
          disabled={!hasCreateApiKeyPermission}>
          <UserKey width={15} height={15} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Criar api-key</Box>
        </MenuItem>
        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('manage-api-key')
          }}
          disabled={!hasManageApiKeyPermission}>
          <FolderKey width={15} height={15} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Gerenciar api-keys</Box>
        </MenuItem>

        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('set-permissions')
          }}
          disabled={disabledRoles.includes(params.role) || params.id === user.id}>
          <img src={PermissionUser} alt='Menu logo' style={{width: 16, height: 16}} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.8}}>Definir Permissões</Box>
        </MenuItem>
        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('send-email')
          }}>
          <img src={IconEmail} alt='Menu logo' style={{width: 16, height: 16}} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.8}}>Reenviar e-mail de acesso</Box>
        </MenuItem>
        <MenuItem
          sx={styles.menuInfos}
          onClick={() => {
            setAnchorEl(null)
            onClick?.('delete')
          }}
          disabled={!hasDeletePermission}>
          <img src={Delete} alt='Menu logo' style={{width: 16, height: 16}} />
          <Box sx={{fontFamily: 'Inter', paddingLeft: 0.9}}>Deletar</Box>
        </MenuItem>
      </Menu>
    </>
  )
}

export default UserMenuOptions

const styles = createStyleSheet({
  menuInfos: {
    fontSize: '12px',
    padding: '5px 12px 5px 12px',
  },
})
